export interface RegisterNotificationMailTemplateRequest {
  subject: string
  body: string
}

export function RegisterNotificationMailTemplateRequestToJSON(
  value: RegisterNotificationMailTemplateRequest
): any {
  return {
    subject: value.subject !== '' ? value.subject : undefined,
    body: value.body !== '' ? value.body : undefined
  }
}
